export default "__VITE_ASSET__BAcoIQ6q__"